import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/table"

import useClanLocalityData from "../../hooks/useClanLocalityData"
import useClanKinshipData from "../../hooks/useClanKinshipData"

const ClanAllYear = () => {

  const localityData = useClanLocalityData()
  const kinshipData  = useClanKinshipData()

  // Sort data in ascending order of year of establishment
  const data = localityData.concat(kinshipData).sort((a, b) => a.yearest - b.yearest)

  const columns = [
    { name: "Year Estab.", key: "yearest" },
    { name: "Name in Chinese", key: "ccchi" },
    { name: "Name in English", key: "cceng" },
    { name: "Type: Locality (L) or Kinship (K)", key: "type" },
    { name: "Kinship/Locality", key: "locality|kinship" },
  ]

  return (
    <Layout>
      <Seo title="Index of Chinese Clan Associations by Year Established" />

      <Container>
			<h1>Index of Chinese Clan Associations by Year Established</h1>

      <Table
        columns={columns}
        data={data}
        paginationSize={20}
				routeLink={() => "/map"}
				routeState={({ id, type }) => ({ clanId: id, clanType: type })}
      />

      </Container>
    </Layout>
  )
}

export default ClanAllYear
